import { useEffect, useRef, useState } from 'react';
import TierUpOverlay from './TierUpOverlay';
import { notificationsApi } from '../api/notificationsApi';
import { useAuth } from '../context/AuthContext';

// Polls the notification summary periodically and shows TierUpOverlay
// for each unread tier_up notification. The matching item is marked
// read on dismiss so we don't replay it. Mounted once at the App
// shell level (App.jsx).
export default function TierUpListener() {
  const { user } = useAuth();
  const [queue, setQueue] = useState([]);
  const [active, setActive] = useState(null);
  const seenRef = useRef(new Set());

  useEffect(() => {
    if (!user) return;
    let alive = true;
    const poll = async () => {
      try {
        const data = await notificationsApi.list();
        const items = data?.notifications || data || [];
        const fresh = items.filter((n) => n.type === 'tier_up' && !n.read && !seenRef.current.has(n._id));
        fresh.forEach((n) => seenRef.current.add(n._id));
        if (fresh.length > 0 && alive) {
          setQueue((q) => [...q, ...fresh]);
        }
      } catch {}
    };
    poll();
    const t = setInterval(poll, 30000);
    return () => { alive = false; clearInterval(t); };
  }, [user]);

  useEffect(() => {
    if (active || queue.length === 0) return;
    const [next, ...rest] = queue;
    setActive(next);
    setQueue(rest);
  }, [queue, active]);

  const dismiss = async () => {
    if (active?._id) {
      try { await notificationsApi.read(active._id); } catch {}
    }
    setActive(null);
  };

  if (!active) return null;
  const reputation = active.payload?.reputation ?? active.data?.reputation ?? 0;
  const delta = active.payload?.delta ?? active.data?.delta ?? 0;
  return <TierUpOverlay visible reputation={reputation} delta={delta} onClose={dismiss} />;
}
